import axiosInstance from '../utils/api-util/utilApi'

export const addPageToFavorites = (payload: any): Promise<any> => axiosInstance.post(`/favoritePage`, payload)

export const removePageFromFavorites = (payload: any): Promise<any> => axiosInstance.put(`/favoritePage`, payload)

export const getAllPages = (): Promise<any> => axiosInstance.get('/api/pages')

export const getFavoritePages = (userId: string): Promise<any> => axiosInstance.get(`/favoritePage/${userId}`)

export const updateFavoritePages = (payload: any): Promise<any> =>
  axiosInstance.put(`/favoritePage/listFavoritePage`, payload)
